export const fieldNameToProperty = (fieldName: string): string => fieldName.replace('company.', '')

export const mapFormDataToObject = (formData: Record<string, any>): Record<string, any> =>
  Object.fromEntries(
    Object.entries(formData).map(([key, value]) => [fieldNameToProperty(key), value])
  )
